/**
 * Analytics utility to report events to Google Analytics (GA4)
 * Uses the global gtag function initialized in index.html
 */

export const AnalyticsEvents = {
  LOGIN: "login",
  SIGN_UP: "sign_up",
  SEARCH: "search",
  BEGIN_CHECKOUT: "begin_checkout", // For donation start
  CONTACT_SUBMIT: "contact_submit",
  CLICK: "click", // Generic click event
  FORM_START: "form_start",
  FILE_DOWNLOAD: "file_download",
  OUTBOUND_CLICK: "outbound_click",
};

/**
 * Tracks a custom event in Google Analytics
 * @param {string} eventName - The name of the event (e.g., 'login', 'search')
 * @param {object} eventParams - Optional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, eventParams);
  } else {
    console.warn("Google Analytics (gtag) is not initialized.");
  }
};

/**
 * Tracks a page view in Google Analytics
 * @param {string} path - The path of the page viewed
 */
export const trackPageView = (path) => {
  if (typeof window.gtag === "function") {
    // GA4 automatically tracks views, but for SPA we usually need to update the path
    window.gtag("event", "page_view", {
      page_path: path,
    });
  }
};

/**
 * Sets the User ID and User Properties
 * @param {string} userId - The User ID
 * @param {object} userProperties - Additional user properties (e.g. { username: '...' })
 */
export const identifyUser = (userId, userProperties = {}) => {
  if (typeof window.gtag === "function") {
    // Set User ID (applied to future events)
    window.gtag("config", process.env.REACT_APP_GTAG, {
      user_id: userId,
    });

    // Set User Properties
    if (Object.keys(userProperties).length > 0) {
      window.gtag("set", "user_properties", userProperties);
    }
  }
};

/**
 * Helper to track button clicks
 * @param {string} buttonName - Name of the button clicked
 * @param {string} location - Where the button is located (e.g., 'header')
 */
export const trackButtonClick = (buttonName, location) => {
  trackEvent(AnalyticsEvents.CLICK, {
    event_category: "button",
    event_label: buttonName,
    location: location,
  });
};
